/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../models/amplify/API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onOngoingCalls = /* GraphQL */ `subscription OnOngoingCalls {
  onOngoingCalls {
    opi {
      callSid
      callId
      pin
      clientNumber
      callStatus
      operators {
        operatorId
        operatorName
        __typename
      }
      outboundPhoneNumbers
      customInputFields {
        name
        value
        isEnabled
        criteriaType
        __typename
      }
      callStartedAt
      durationMilliseconds
      languageName
      __typename
    }
    vri {
      roomSid
      roomStatus
      uniqueName
      callId
      chatSid
      roomCreatedAt
      durationMilliseconds
      participantsUrl
      participants {
        userId
        status
        callParticipantType
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnOngoingCallsSubscriptionVariables,
  APITypes.OnOngoingCallsSubscription
>;
